import CommunityTabBar from './CommunityTabBar'

export default CommunityTabBar
export type { CommunityTabBarProps, CommunityTabItem } from './CommunityTabBar'
